// extracted by mini-css-extract-plugin
export default {"mediaPara":"Media_mediaPara__-qYye","toggleBox":"Media_toggleBox__UvcCi","toggleHeading":"Media_toggleHeading__Zqw1G","toggle":"Media_toggle__zCbU5","delBtn":"Media_delBtn__spD5y"};